import React from "react";
import LogoLinkAja from "../../assets/logo/linkAja.png";
const DetailTransaction = () => {
  return (
    <div className="w-full py-3 flex">
      <div className="flex flex-col w-8/12">
        {/* Card Detail */}
        <div className="bg-white rounded-md text-font-gray">
          <div className="flex py-6 px-8 border-b border-gray-300">
            <h4>Keterangan Pengantaran</h4>
            <div className="flex ml-auto max-w-xs justify-between w-full">
              <button className="flex items-center">
                <div className="bg-green-500 rounded-full h-8 w-8 flex items-center justify-center mr-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="35"
                    height="35"
                    viewBox="0 0 35 35"
                  >
                    <circle
                      id="Ellipse_229"
                      data-name="Ellipse 229"
                      cx="17.5"
                      cy="17.5"
                      r="17.5"
                      fill="#439521"
                      opacity="0.9"
                    />
                    <path
                      id="Icon_awesome-compass"
                      data-name="Icon awesome-compass"
                      d="M9.534,10.1a1.354,1.354,0,1,0,1.914,0,1.353,1.353,0,0,0-1.914,0ZM10.491.563A10.491,10.491,0,1,0,20.982,11.053,10.491,10.491,0,0,0,10.491.563Zm5.336,6.263-2.791,6.106a1.351,1.351,0,0,1-.667.667L6.263,16.389a.836.836,0,0,1-1.108-1.108L7.946,9.175a1.351,1.351,0,0,1,.667-.667l6.106-2.791A.836.836,0,0,1,15.827,6.825Z"
                      transform="translate(7 6.331)"
                      fill="#fff"
                    />
                  </svg>
                </div>
                <p>Map</p>
              </button>
              <button className="flex items-center">
                <div className="bg-green-500 rounded-full h-8 w-8 flex items-center justify-center mr-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="35"
                    height="35"
                    viewBox="0 0 35 35"
                  >
                    <path
                      id="Path_1318"
                      data-name="Path 1318"
                      d="M17.5,0A17.5,17.5,0,1,1,0,17.5,17.5,17.5,0,0,1,17.5,0Z"
                      fill="#439521"
                      opacity="0.9"
                    />
                    <path
                      id="Icon_ionic-logo-whatsapp"
                      data-name="Icon ionic-logo-whatsapp"
                      d="M12.431,2.25a9.781,9.781,0,0,0-9.818,9.742,9.642,9.642,0,0,0,1.409,5.031L2.25,22.25l5.436-1.727A9.835,9.835,0,0,0,22.25,11.992,9.781,9.781,0,0,0,12.431,2.25Zm4.882,13.442a2.536,2.536,0,0,1-1.737,1.119c-.46.024-.474.357-2.984-.734a10.244,10.244,0,0,1-4.139-3.914,4.815,4.815,0,0,1-.926-2.61,2.782,2.782,0,0,1,.956-2.041.962.962,0,0,1,.68-.286c.2,0,.326-.006.472,0S10,7.2,10.191,7.7s.645,1.748.7,1.875a.455.455,0,0,1,0,.436,1.705,1.705,0,0,1-.266.405c-.131.141-.276.314-.393.422s-.267.249-.129.5a7.513,7.513,0,0,0,1.329,1.774,6.85,6.85,0,0,0,1.969,1.309c.246.134.393.119.546-.041s.654-.7.83-.945.342-.2.569-.1,1.436.739,1.682.873.41.2.469.308A2.062,2.062,0,0,1,17.314,15.692Z"
                      transform="translate(5.75 4.771)"
                      fill="#fff"
                    />
                  </svg>
                </div>
                <p>Whatsapp</p>
              </button>
              <button className="flex items-center">
                <div className="bg-green-500 rounded-full h-8 w-8 flex items-center justify-center mr-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="35"
                    height="35"
                    viewBox="0 0 35 35"
                  >
                    <circle
                      id="Ellipse_288"
                      data-name="Ellipse 288"
                      cx="17.5"
                      cy="17.5"
                      r="17.5"
                      fill="#439521"
                      opacity="0.9"
                    />
                    <path
                      id="Icon_material-print"
                      data-name="Icon material-print"
                      d="M18.626,9.1H5.758A2.754,2.754,0,0,0,3,11.854v5.515H6.677v3.677h11.03V17.369h3.677V11.854A2.754,2.754,0,0,0,18.626,9.1ZM15.869,19.207H8.515v-4.6h7.354Zm2.758-6.434a.919.919,0,1,1,.919-.919A.922.922,0,0,1,18.626,12.773ZM17.707,4.5H6.677V8.177h11.03Z"
                      transform="translate(5 4.5)"
                      fill="#fff"
                    />
                  </svg>
                </div>
                <p>Print</p>
              </button>
            </div>
          </div>
          <div className="flex  px-8">
            <div className="flex w-full">
              <div className=" max-w-md w-full py-6">
                <p>Detail Pengantaran :</p>
                <div className="flex mt-2">
                  <span className="mr-4">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="13.995"
                      height="18.66"
                      viewBox="0 0 13.995 18.66"
                    >
                      <path
                        id="Icon_awesome-map-marker-alt"
                        data-name="Icon awesome-map-marker-alt"
                        d="M6.278,18.284C.983,10.607,0,9.819,0,7A7,7,0,1,1,14,7c0,2.821-.983,3.609-6.278,11.286A.875.875,0,0,1,6.278,18.284ZM7,9.913A2.916,2.916,0,1,0,4.082,7,2.916,2.916,0,0,0,7,9.913Z"
                        fill="#596375"
                      />
                    </svg>
                  </span>
                  <p>Perumahan Permata Jingga, Blok B No.6</p>
                </div>
              </div>
              <div className="flex flex-col border-l border-gray-300 py-6 px-8">
                <p>Pembayaran Melalui :</p>
                <div className="flex items-center mt-2">
                  <img
                    src={LogoLinkAja}
                    alt="LinkAja"
                    className="h-8 w-8 mr-2"
                  />
                  <p>Link Aja</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* End Card Detail */}
        {/* Table Deatil */}
        <table className="table-auto mt-4 rounded-md w-full">
          <thead>
            <tr className="bg-gray-300 text-font-gray">
              <th className="py-3 px-6 font-normal w-5/12 text-left">
                Item Barang
              </th>
              <th className="py-3 px-6 font-normal w-2/12 text-center">
                Jumlah
              </th>
              <th className="py-3 px-6 font-normal w-2/12 text-center">
                Harga
              </th>
              <th className="py-3 px-6 font-normal w-2/12 text-center">
                Tindalan
              </th>
            </tr>
          </thead>
          <tbody className="bg-white">
            <tr>
              <td className="py-3 px-6 w-5/12">Daging Sapi 250g</td>
              <td className="py-3 px-6 w-2/12 text-center">2</td>
              <td className="py-3 px-6 w-2/12 text-center">Rp.65.000</td>
              <td className="py-3 px-6 w-2/12 text-center">
                <button class="mx-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18.466"
                    height="22.612"
                    viewBox="0 0 18.466 22.612"
                  >
                    <g
                      id="Group_3841"
                      data-name="Group 3841"
                      transform="translate(-1255.75 -698.486)"
                    >
                      <g id="Group_3840" data-name="Group 3840">
                        <path
                          id="Icon_metro-bin"
                          data-name="Icon metro-bin"
                          d="M5.881,8.838v13.82A1.386,1.386,0,0,0,7.263,24.04H19.7a1.386,1.386,0,0,0,1.382-1.382V8.838H5.881Zm4.146,12.438H8.645V11.6h1.382Zm2.764,0H11.409V11.6h1.382Zm2.764,0H14.173V11.6h1.382Zm2.764,0H16.937V11.6h1.382Zm3.11-16.584H16.937V2.965A1.04,1.04,0,0,0,15.9,1.928H11.063a1.04,1.04,0,0,0-1.037,1.037V4.692H5.535A1.04,1.04,0,0,0,4.5,5.729V7.456H22.465V5.729a1.04,1.04,0,0,0-1.037-1.037Zm-5.874,0H11.409V3.327h4.146V4.692Z"
                          transform="translate(1251.501 696.808)"
                          fill="#f68906"
                          stroke="#fff"
                          strokeWidth="0.5"
                        />
                      </g>
                      <g
                        id="Rectangle_2708"
                        data-name="Rectangle 2708"
                        transform="translate(1260 708)"
                        fill="#fff"
                        stroke="#fff"
                        strokeWidth="0.5"
                      >
                        <path
                          d="M0,0H10a0,0,0,0,1,0,0V10a1,1,0,0,1-1,1H1a1,1,0,0,1-1-1V0A0,0,0,0,1,0,0Z"
                          stroke="none"
                        />
                        <path
                          d="M.5.25h9A.25.25,0,0,1,9.75.5V10a.75.75,0,0,1-.75.75H1A.75.75,0,0,1,.25,10V.5A.25.25,0,0,1,.5.25Z"
                          fill="none"
                        />
                      </g>
                    </g>
                  </svg>
                </button>
              </td>
            </tr>
            <tr>
              <td className="py-3 px-6 w-5/12">Daging Sapi 250g</td>
              <td className="py-3 px-6 w-2/12 text-center">2</td>
              <td className="py-3 px-6 w-2/12 text-center">Rp.65.000</td>
              <td className="py-3 px-6 w-2/12 text-center">
                <button class="mx-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18.466"
                    height="22.612"
                    viewBox="0 0 18.466 22.612"
                  >
                    <g
                      id="Group_3841"
                      data-name="Group 3841"
                      transform="translate(-1255.75 -698.486)"
                    >
                      <g id="Group_3840" data-name="Group 3840">
                        <path
                          id="Icon_metro-bin"
                          data-name="Icon metro-bin"
                          d="M5.881,8.838v13.82A1.386,1.386,0,0,0,7.263,24.04H19.7a1.386,1.386,0,0,0,1.382-1.382V8.838H5.881Zm4.146,12.438H8.645V11.6h1.382Zm2.764,0H11.409V11.6h1.382Zm2.764,0H14.173V11.6h1.382Zm2.764,0H16.937V11.6h1.382Zm3.11-16.584H16.937V2.965A1.04,1.04,0,0,0,15.9,1.928H11.063a1.04,1.04,0,0,0-1.037,1.037V4.692H5.535A1.04,1.04,0,0,0,4.5,5.729V7.456H22.465V5.729a1.04,1.04,0,0,0-1.037-1.037Zm-5.874,0H11.409V3.327h4.146V4.692Z"
                          transform="translate(1251.501 696.808)"
                          fill="#f68906"
                          stroke="#fff"
                          strokeWidth="0.5"
                        />
                      </g>
                      <g
                        id="Rectangle_2708"
                        data-name="Rectangle 2708"
                        transform="translate(1260 708)"
                        fill="#fff"
                        stroke="#fff"
                        strokeWidth="0.5"
                      >
                        <path
                          d="M0,0H10a0,0,0,0,1,0,0V10a1,1,0,0,1-1,1H1a1,1,0,0,1-1-1V0A0,0,0,0,1,0,0Z"
                          stroke="none"
                        />
                        <path
                          d="M.5.25h9A.25.25,0,0,1,9.75.5V10a.75.75,0,0,1-.75.75H1A.75.75,0,0,1,.25,10V.5A.25.25,0,0,1,.5.25Z"
                          fill="none"
                        />
                      </g>
                    </g>
                  </svg>
                </button>
              </td>
            </tr>
            <tr>
              <td className="py-3 px-6 w-5/12">Daging Sapi 250g</td>
              <td className="py-3 px-6 w-2/12 text-center">2</td>
              <td className="py-3 px-6 w-2/12 text-center">Rp.65.000</td>
              <td className="py-3 px-6 w-2/12 text-center">
                <button class="mx-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18.466"
                    height="22.612"
                    viewBox="0 0 18.466 22.612"
                  >
                    <g
                      id="Group_3841"
                      data-name="Group 3841"
                      transform="translate(-1255.75 -698.486)"
                    >
                      <g id="Group_3840" data-name="Group 3840">
                        <path
                          id="Icon_metro-bin"
                          data-name="Icon metro-bin"
                          d="M5.881,8.838v13.82A1.386,1.386,0,0,0,7.263,24.04H19.7a1.386,1.386,0,0,0,1.382-1.382V8.838H5.881Zm4.146,12.438H8.645V11.6h1.382Zm2.764,0H11.409V11.6h1.382Zm2.764,0H14.173V11.6h1.382Zm2.764,0H16.937V11.6h1.382Zm3.11-16.584H16.937V2.965A1.04,1.04,0,0,0,15.9,1.928H11.063a1.04,1.04,0,0,0-1.037,1.037V4.692H5.535A1.04,1.04,0,0,0,4.5,5.729V7.456H22.465V5.729a1.04,1.04,0,0,0-1.037-1.037Zm-5.874,0H11.409V3.327h4.146V4.692Z"
                          transform="translate(1251.501 696.808)"
                          fill="#f68906"
                          stroke="#fff"
                          strokeWidth="0.5"
                        />
                      </g>
                      <g
                        id="Rectangle_2708"
                        data-name="Rectangle 2708"
                        transform="translate(1260 708)"
                        fill="#fff"
                        stroke="#fff"
                        strokeWidth="0.5"
                      >
                        <path
                          d="M0,0H10a0,0,0,0,1,0,0V10a1,1,0,0,1-1,1H1a1,1,0,0,1-1-1V0A0,0,0,0,1,0,0Z"
                          stroke="none"
                        />
                        <path
                          d="M.5.25h9A.25.25,0,0,1,9.75.5V10a.75.75,0,0,1-.75.75H1A.75.75,0,0,1,.25,10V.5A.25.25,0,0,1,.5.25Z"
                          fill="none"
                        />
                      </g>
                    </g>
                  </svg>
                </button>
              </td>
            </tr>
            <tr>
              <td className="py-3 px-6 w-5/12">Daging Sapi 250g</td>
              <td className="py-3 px-6 w-2/12 text-center">2</td>
              <td className="py-3 px-6 w-2/12 text-center">Rp.65.000</td>
              <td className="py-3 px-6 w-2/12 text-center">
                <button class="mx-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18.466"
                    height="22.612"
                    viewBox="0 0 18.466 22.612"
                  >
                    <g
                      id="Group_3841"
                      data-name="Group 3841"
                      transform="translate(-1255.75 -698.486)"
                    >
                      <g id="Group_3840" data-name="Group 3840">
                        <path
                          id="Icon_metro-bin"
                          data-name="Icon metro-bin"
                          d="M5.881,8.838v13.82A1.386,1.386,0,0,0,7.263,24.04H19.7a1.386,1.386,0,0,0,1.382-1.382V8.838H5.881Zm4.146,12.438H8.645V11.6h1.382Zm2.764,0H11.409V11.6h1.382Zm2.764,0H14.173V11.6h1.382Zm2.764,0H16.937V11.6h1.382Zm3.11-16.584H16.937V2.965A1.04,1.04,0,0,0,15.9,1.928H11.063a1.04,1.04,0,0,0-1.037,1.037V4.692H5.535A1.04,1.04,0,0,0,4.5,5.729V7.456H22.465V5.729a1.04,1.04,0,0,0-1.037-1.037Zm-5.874,0H11.409V3.327h4.146V4.692Z"
                          transform="translate(1251.501 696.808)"
                          fill="#f68906"
                          stroke="#fff"
                          strokeWidth="0.5"
                        />
                      </g>
                      <g
                        id="Rectangle_2708"
                        data-name="Rectangle 2708"
                        transform="translate(1260 708)"
                        fill="#fff"
                        stroke="#fff"
                        strokeWidth="0.5"
                      >
                        <path
                          d="M0,0H10a0,0,0,0,1,0,0V10a1,1,0,0,1-1,1H1a1,1,0,0,1-1-1V0A0,0,0,0,1,0,0Z"
                          stroke="none"
                        />
                        <path
                          d="M.5.25h9A.25.25,0,0,1,9.75.5V10a.75.75,0,0,1-.75.75H1A.75.75,0,0,1,.25,10V.5A.25.25,0,0,1,.5.25Z"
                          fill="none"
                        />
                      </g>
                    </g>
                  </svg>
                </button>
              </td>
            </tr>

            <tr>
              <td className="py-3 px-6 w-5/12">Daging Sapi 250g</td>
              <td className="py-3 px-6 w-2/12 text-center">2</td>
              <td className="py-3 px-6 w-2/12 text-center">Rp.65.000</td>
              <td className="py-3 px-6 w-2/12 text-center">
                <button class="mx-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18.466"
                    height="22.612"
                    viewBox="0 0 18.466 22.612"
                  >
                    <g
                      id="Group_3841"
                      data-name="Group 3841"
                      transform="translate(-1255.75 -698.486)"
                    >
                      <g id="Group_3840" data-name="Group 3840">
                        <path
                          id="Icon_metro-bin"
                          data-name="Icon metro-bin"
                          d="M5.881,8.838v13.82A1.386,1.386,0,0,0,7.263,24.04H19.7a1.386,1.386,0,0,0,1.382-1.382V8.838H5.881Zm4.146,12.438H8.645V11.6h1.382Zm2.764,0H11.409V11.6h1.382Zm2.764,0H14.173V11.6h1.382Zm2.764,0H16.937V11.6h1.382Zm3.11-16.584H16.937V2.965A1.04,1.04,0,0,0,15.9,1.928H11.063a1.04,1.04,0,0,0-1.037,1.037V4.692H5.535A1.04,1.04,0,0,0,4.5,5.729V7.456H22.465V5.729a1.04,1.04,0,0,0-1.037-1.037Zm-5.874,0H11.409V3.327h4.146V4.692Z"
                          transform="translate(1251.501 696.808)"
                          fill="#f68906"
                          stroke="#fff"
                          strokeWidth="0.5"
                        />
                      </g>
                      <g
                        id="Rectangle_2708"
                        data-name="Rectangle 2708"
                        transform="translate(1260 708)"
                        fill="#fff"
                        stroke="#fff"
                        strokeWidth="0.5"
                      >
                        <path
                          d="M0,0H10a0,0,0,0,1,0,0V10a1,1,0,0,1-1,1H1a1,1,0,0,1-1-1V0A0,0,0,0,1,0,0Z"
                          stroke="none"
                        />
                        <path
                          d="M.5.25h9A.25.25,0,0,1,9.75.5V10a.75.75,0,0,1-.75.75H1A.75.75,0,0,1,.25,10V.5A.25.25,0,0,1,.5.25Z"
                          fill="none"
                        />
                      </g>
                    </g>
                  </svg>
                </button>
              </td>
            </tr>

            <tr>
              <td className="py-3 px-6 w-5/12">Daging Sapi 250g</td>
              <td className="py-3 px-6 w-2/12 text-center">2</td>
              <td className="py-3 px-6 w-2/12 text-center">Rp.65.000</td>
              <td className="py-3 px-6 w-2/12 text-center">
                <button class="mx-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18.466"
                    height="22.612"
                    viewBox="0 0 18.466 22.612"
                  >
                    <g
                      id="Group_3841"
                      data-name="Group 3841"
                      transform="translate(-1255.75 -698.486)"
                    >
                      <g id="Group_3840" data-name="Group 3840">
                        <path
                          id="Icon_metro-bin"
                          data-name="Icon metro-bin"
                          d="M5.881,8.838v13.82A1.386,1.386,0,0,0,7.263,24.04H19.7a1.386,1.386,0,0,0,1.382-1.382V8.838H5.881Zm4.146,12.438H8.645V11.6h1.382Zm2.764,0H11.409V11.6h1.382Zm2.764,0H14.173V11.6h1.382Zm2.764,0H16.937V11.6h1.382Zm3.11-16.584H16.937V2.965A1.04,1.04,0,0,0,15.9,1.928H11.063a1.04,1.04,0,0,0-1.037,1.037V4.692H5.535A1.04,1.04,0,0,0,4.5,5.729V7.456H22.465V5.729a1.04,1.04,0,0,0-1.037-1.037Zm-5.874,0H11.409V3.327h4.146V4.692Z"
                          transform="translate(1251.501 696.808)"
                          fill="#f68906"
                          stroke="#fff"
                          strokeWidth="0.5"
                        />
                      </g>
                      <g
                        id="Rectangle_2708"
                        data-name="Rectangle 2708"
                        transform="translate(1260 708)"
                        fill="#fff"
                        stroke="#fff"
                        strokeWidth="0.5"
                      >
                        <path
                          d="M0,0H10a0,0,0,0,1,0,0V10a1,1,0,0,1-1,1H1a1,1,0,0,1-1-1V0A0,0,0,0,1,0,0Z"
                          stroke="none"
                        />
                        <path
                          d="M.5.25h9A.25.25,0,0,1,9.75.5V10a.75.75,0,0,1-.75.75H1A.75.75,0,0,1,.25,10V.5A.25.25,0,0,1,.5.25Z"
                          fill="none"
                        />
                      </g>
                    </g>
                  </svg>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        {/* End Table Deatil */}
      </div>
      <div className="flex flex-col items-start w-4/12 pl-4">
        {/* Card */}
        <div className="bg-white rounded-md text-font-gray h-auto w-full">
          <div className="flex py-6 px-8 border-b border-gray-300">
            <p>Status Pengantaran</p>
          </div>
          <div className="flex flex-col py-6 px-8 ">
            <p>Pilih tindakan untuk pesan ini</p>
            <button className="px-8 py-2 my-2 rounded-md align-center border border-green-500 bg-green-500 text-white">
              Antarkan Pesanan
            </button>
            <button className="px-8 py-2 my-2 rounded-md align-center border border-orange-500 bg-white text-orange-500">
              Batalkan Pesanan
            </button>
          </div>
        </div>
        {/* Card End */}
        {/* Timeline */}
        <div className=" py-4 px-6 w-full">
          <div className="flex flex-col text-sm max-w-xs mx-auto lg:w-9/12">
            <h5 className="mb-5 ml-8">Status</h5>
            <div className="flex items-center mb-8">
              <p className=" ">20:00</p>
              <div className="h-4 w-4 mx-3 icons-timeline">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
                  <g id="Path_1322" data-name="Path 1322" fill="#fff">
                    <path
                      d="M 9 16 C 5.140190124511719 16 2 12.85980987548828 2 9 C 2 5.140190124511719 5.140190124511719 2 9 2 C 12.85980987548828 2 16 5.140190124511719 16 9 C 16 12.85980987548828 12.85980987548828 16 9 16 Z"
                      stroke="none"
                    />
                    <path
                      d="M 9 4 C 6.242989540100098 4 4 6.242989540100098 4 9 C 4 11.75700950622559 6.242989540100098 14 9 14 C 11.75700950622559 14 14 11.75700950622559 14 9 C 14 6.242989540100098 11.75700950622559 4 9 4 M 9 0 C 13.97056007385254 0 18 4.029439926147461 18 9 C 18 13.97056007385254 13.97056007385254 18 9 18 C 4.029439926147461 18 0 13.97056007385254 0 9 C 0 4.029439926147461 4.029439926147461 0 9 0 Z"
                      stroke="none"
                      fill="#d7dadb"
                    />
                  </g>
                </svg>
              </div>
              <p>Dipesan</p>
              <p className="ml-auto">17 Okt 2020</p>
            </div>
            <div className="flex items-center mb-8">
              <p className=" ">20:00</p>
              <div className="h-4 w-4 mx-3 icons-timeline">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
                  <g id="Path_1322" data-name="Path 1322" fill="#fff">
                    <path
                      d="M 9 16 C 5.140190124511719 16 2 12.85980987548828 2 9 C 2 5.140190124511719 5.140190124511719 2 9 2 C 12.85980987548828 2 16 5.140190124511719 16 9 C 16 12.85980987548828 12.85980987548828 16 9 16 Z"
                      stroke="none"
                    />
                    <path
                      d="M 9 4 C 6.242989540100098 4 4 6.242989540100098 4 9 C 4 11.75700950622559 6.242989540100098 14 9 14 C 11.75700950622559 14 14 11.75700950622559 14 9 C 14 6.242989540100098 11.75700950622559 4 9 4 M 9 0 C 13.97056007385254 0 18 4.029439926147461 18 9 C 18 13.97056007385254 13.97056007385254 18 9 18 C 4.029439926147461 18 0 13.97056007385254 0 9 C 0 4.029439926147461 4.029439926147461 0 9 0 Z"
                      stroke="none"
                      fill="#d7dadb"
                    />
                  </g>
                </svg>
              </div>
              <p>Diproses</p>
              <p className="ml-auto">17 Okt 2020</p>
            </div>
            <div className="flex items-center mb-8">
              <p className=" ">20:00</p>
              <div className="h-4 w-4 mx-3 icons-timeline">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
                  <g id="Path_1322" data-name="Path 1322" fill="#fff">
                    <path
                      d="M 9 16 C 5.140190124511719 16 2 12.85980987548828 2 9 C 2 5.140190124511719 5.140190124511719 2 9 2 C 12.85980987548828 2 16 5.140190124511719 16 9 C 16 12.85980987548828 12.85980987548828 16 9 16 Z"
                      stroke="none"
                    />
                    <path
                      d="M 9 4 C 6.242989540100098 4 4 6.242989540100098 4 9 C 4 11.75700950622559 6.242989540100098 14 9 14 C 11.75700950622559 14 14 11.75700950622559 14 9 C 14 6.242989540100098 11.75700950622559 4 9 4 M 9 0 C 13.97056007385254 0 18 4.029439926147461 18 9 C 18 13.97056007385254 13.97056007385254 18 9 18 C 4.029439926147461 18 0 13.97056007385254 0 9 C 0 4.029439926147461 4.029439926147461 0 9 0 Z"
                      stroke="none"
                      fill="#d7dadb"
                    />
                  </g>
                </svg>
              </div>
              <p>Dikirim</p>
              <p className="ml-auto">17 Okt 2020</p>
            </div>
            <div className="flex items-center mb-8">
              <p className=" ">20:00</p>
              <div className="h-4 w-4 mx-3 ">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
                  <g id="Path_1322" data-name="Path 1322" fill="#fff">
                    <path
                      d="M 9 16 C 5.140190124511719 16 2 12.85980987548828 2 9 C 2 5.140190124511719 5.140190124511719 2 9 2 C 12.85980987548828 2 16 5.140190124511719 16 9 C 16 12.85980987548828 12.85980987548828 16 9 16 Z"
                      stroke="none"
                    />
                    <path
                      d="M 9 4 C 6.242989540100098 4 4 6.242989540100098 4 9 C 4 11.75700950622559 6.242989540100098 14 9 14 C 11.75700950622559 14 14 11.75700950622559 14 9 C 14 6.242989540100098 11.75700950622559 4 9 4 M 9 0 C 13.97056007385254 0 18 4.029439926147461 18 9 C 18 13.97056007385254 13.97056007385254 18 9 18 C 4.029439926147461 18 0 13.97056007385254 0 9 C 0 4.029439926147461 4.029439926147461 0 9 0 Z"
                      stroke="none"
                      fill="#d7dadb"
                    />
                  </g>
                </svg>
              </div>
              <p>Diterima</p>
              <p className="ml-auto">17 Okt 2020</p>
            </div>
            <div className="flex">
              <div></div>
            </div>
          </div>
        </div>
        {/* Timeline End */}
      </div>
    </div>
  );
};

export default DetailTransaction;
